import { render, staticRenderFns } from "./DocumentSummaryItemDeleteConfirmationPopup.vue?vue&type=template&id=1440735e&scoped=true"
import script from "./DocumentSummaryItemDeleteConfirmationPopup.vue?vue&type=script&lang=js"
export * from "./DocumentSummaryItemDeleteConfirmationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1440735e",
  null
  
)

export default component.exports